import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { GroupDetail } from './GroupDetail'
import { useSelector } from 'react-redux'
import { ChatGroupList } from './ChatGroupList'
import { Control } from './Control'
export const DirectMessagingBackend = () => {
  var [isOpen, setOpen] = useState(false);
  var [count, setCount] = useState(0);
  const DMStore = useSelector((state) => state.DirectMessaging);
  useEffect(() => {
    setCount(DMStore?.group?.reduce((accumulator, object) => { return accumulator + (object.customer_chat_count || 0) }, 0))
  }, [DMStore, DMStore?.group]);
  return (
    <>
      <Control />
      <div className="direct-messaging-icon" onClick={() => setOpen(true)}>
        <i className="fas fa-comments fa-2x"></i>
        <div className="badge">
          {count > 0 && count}
        </div>
      </div>
      <div className={clsx({
        'direct-messaging': true,
        'active': isOpen
      })}>
        <ChatGroupList />
        <GroupDetail onClose={() => setOpen(false)} />
      </div>
    </>
  );
};
